import React, { useState } from 'react';
import LockInButton from './../LockInButton/LockInButton'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import './DraggableList.scss'
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from "@mui/styles";


function DraggableList(props) {

    function reorder(list, startIndex, endIndex) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const grid = 6;

    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: "none",
        padding: 10,
        margin: `0 0 ${grid}px 0`,

        background: isDragging ? "#B2292D" : "#F7F7F7",
        color: isDragging ? "white" : "black",
        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = {
        background: props.isAnswer ? "#B2292D" : '#E7DCDA',
        padding: grid,
        width: "100%"
    };

    const useStyles = makeStyles(theme => ({
        arrow: {
          "&:before": {
            border: "1px solid #E7DCDA",
            backgroundColor: "#B2292D",
          },
          color: "#FFF"
        },
        tooltip: {
          backgroundColor: "#B2292D",
          border: "1px solid #E7DCDA",
          color: "#FFF",
          fontSize: '11pt',
        }
    }));

    let classes = useStyles();
    
    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const items = reorder(
            props.options,
            result.source.index,
            result.destination.index
        );
        props.setOptions(items)
        props.setDisplayTooltip(false)
  }

    return (
        <div>
            <DragDropContext onDragEnd={onDragEnd}>
            <Grid container spacing={2}>
                <Grid item xs={1}>
                    {/* {props.isAnswer ? 
                        <div className='rank-numbering-container'>
                            {props.options.map((option, _) => (
                                <p className='rank-numbering' key={option.id}>{option.percent}%</p>
                            ))}
                        </div>
                        :  */}
                        <div className='rank-numbering-container'>
                           { props.options.map((option, index) => (
                                <p className='rank-numbering' key={option.id}>{index + 1}</p>
                            ))}
                        </div>
                    {/* } */}
                </Grid>
                <Tooltip title="Drag to rank from most to least popular" arrow open={props.displayTooltip} placement='right-start' classes={{ arrow: classes.arrow, tooltip: classes.tooltip }} >
                    <Grid item xs={11} className='draggable-list-container'>
                        <Droppable droppableId="droppable" className='draggable-list-container'>
                        {(provided, snapshot) => (
                            <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={getListStyle}
                            >
                            {props.options.map((item, index) => (
                                <Draggable isDragDisabled={props.disabled} key={item.id} draggableId={item.id} index={index}>
                                {(provided, snapshot) => (
                                    <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                    )}
                                    >
                                        {props.isAnswer ? 
                                            <Grid container>
                                                <Grid item xs={2} className='percent'>{item.percent}% </Grid>
                                                <Grid item xs={10} className={index === 0 ? 'first-option' : 'option'}><p>{item.content}</p></Grid>
    
                                            </Grid> 
                                            :
                                        <p>{item.content}</p> 
                                        }
                                    </div>
                                )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                            </div>
                        )}
                        </Droppable>
                    </Grid>
                </Tooltip>
            </Grid>
            </DragDropContext>
            {props.disabled ? null : 
                <LockInButton response={props.options} handleLockInResponse={() => { props.setDisplayTooltip(false); props.handleLockInResponse(props.options) }}/>
            }
      </div>
    );
  }

export default DraggableList;
